import type { ReactNode } from 'react';

import { cn } from '../../lib/cn';
import styles from './Page.module.css';

/** Ширины страниц (docs/06 §1): других значений у Page нет. */
export type PageWidth = 'narrow' | 'normal' | 'wide' | 'full';

/** Вертикальный ритм — только шаги шкалы отступов. */
export type PageGap = 's-1' | 's-2' | 's-3' | 's-4' | 's-5' | 's-6';

export type PageProps = {
  readonly width?: PageWidth;
  readonly gap?: PageGap;
  readonly children: ReactNode;
};

/** Каркас страницы: одинаковые поля, ширину и ритм для всех экранов. */
export function Page({ width = 'normal', gap = 's-4', children }: PageProps) {
  return <div className={cn(styles['page'], styles[width], styles[gap])}>{children}</div>;
}
